import dayjs from 'dayjs'
import { z } from 'zod'

export const customerSendPermissions = [
  'customer.read',
  'bill.read',
  'bill.group.read',
  'bill.group.create',
  'bill.group.issue',
  'bill.group.send'
] as const
export const customerSendRangeSchema = z
  .object({
    customerId: z.number().int().positive(),
    createdFrom: z.iso.datetime({ offset: true }),
    createdTo: z.iso.datetime({ offset: true })
  })
  .refine((value) => !dayjs(value.createdFrom).isAfter(value.createdTo), '结束时间不能早于开始时间')
export const customerSendPreviewInputSchema = customerSendRangeSchema.safeExtend({
  current: z.number().int().positive().default(1),
  pageSize: z.number().int().positive().max(100).default(20)
})
export const customerSendSchema = customerSendRangeSchema.safeExtend({
  expectedState: z.string().length(64),
  idempotencyKey: z.uuid(),
  botId: z.uuid(),
  accounts: z
    .array(z.object({ organizationId: z.number().int().positive(), accountId: z.number().int().positive() }))
    .min(1)
    .max(100)
    .refine(
      (accounts) => new Set(accounts.map((account) => account.organizationId)).size === accounts.length,
      '收款主体不能重复'
    )
})
export type CustomerSendInput = z.infer<typeof customerSendSchema>
